import React, { Component, Button } from 'react';
import Iframe from 'react-iframe';
import Accordion from 'react-bootstrap/Accordion';
import { Card } from "react-bootstrap";

export class IFrame extends Component {
  render() {
    return (
      <div id="events" className="text-center">
        <div className="container">
          <div className="eventsTitle">
            <h2>{this.props.data ? this.props.data.h2 : 'loading...'}</h2>
            <p>{this.props.data ? this.props.data.paragraph : 'loading...'}</p>
          </div>
          <Accordion defaultActiveKey="1">
            <Card>
              <Card.Header>
                <Accordion.Toggle className="btn btn-custom btn-lg btn-events" as={Button} variant="link" eventKey="0">
                  Events
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <div>
                  <Iframe url="https://www.kartevonmorgen.org/#/?center=47.434,9.687&zoom=9.20&search=%23Pflanzentausch"
                    width="100%"
                    height="600px"
                    id="myId"
                    className="myClassname"
                    display="initial"
                    position="relative" />
                </div>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
      </div>
    )
  }
}


export default IFrame;
